var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row p-10"},[_c('base-year-combo-box',{ref:'baseYearComboBox',on:{"search":_vm.onSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }